import React from 'react';
import { Box, Stepper, Step, StepLabel, CssBaseline } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const darkGreen = '#006400'; // Dark green
const lightGreen = '#228B22'; // Lighter green for completed steps

const theme = createTheme({
    palette: {
        primary: {
            main: darkGreen,
            light: lightGreen,
        },
    },
    components: {
        MuiStepConnector: {
            styleOverrides: {
                line: ({ theme }) => ({
                    borderTop: '1px solid',
                    borderColor: theme.palette.divider,
                    flex: 1,
                    borderRadius: '99px',
                }),
            },
        },
        MuiStepIcon: {
            styleOverrides: {
                root: ({ theme }) => ({
                    color: 'transparent', // Base color is transparent
                    border: `1px solid #aaa`, // Fallback border color
                    width: 12,
                    height: 12,
                    borderRadius: '50%',
                    // Hide the number text inside the step icon
                    '& .MuiStepIcon-text': {
                        display: 'none',
                    },
                    '&.Mui-active': {
                        border: 'none',
                        color: darkGreen, // Active step color: dark green
                    },
                    '&.Mui-completed': {
                        border: 'none',
                        color: lightGreen, // Completed step color: light green
                    },
                }),
            },
        },
        MuiStepLabel: {
            styleOverrides: {
                label: ({ theme }) => ({
                    '&.Mui-completed': {
                        opacity: 0.6,
                    },
                }),
            },
        },
    },
});


export default function PresentationStepper({ activeStep, steps }) {

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Box sx={{ width: '100%', p: 2 }}>
                <Stepper activeStep={activeStep}>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Box>
        </ThemeProvider>
    );
}
